import { React, useEffect, useState, useCallback }  from "react";
import axios from "axios";

import "./ReviewDetails.css";
import { API_BASE_URL } from "../../Variables";
import StarRating from "../StarRating";
import ReviewModal from "../ReviewModal";

/**
 * Review details component, used in CurrentlyReadingDetailsModal
 * @param {*} bookId - The book id
 * @returns 
 */
function ReviewDetails( {bookId} ) {
  const token = localStorage.getItem('token');

  const [review, setReview] = useState(null);
  const [displayReviewModal, setDisplayReviewModal] = useState(false);
  const [error, setError] = useState(null);

  // Open the review modal
  const handleReviewModal = () => {
    setDisplayReviewModal(true);
  };

  // Close the review modal
  const closeReviewModal = () => {
    setDisplayReviewModal(false);
    fetchReview();
  }

  // Fetch the review
  const fetchReview = useCallback(async () => {
    try{
      const response =  await axios.get(`${API_BASE_URL}/reviews/${bookId}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { book_id: bookId }
      });
      setError(null);
      setReview(response.data);
    } catch (error) {
      setError(error);
    }
  }, [bookId, token]);

  // Fetch the review on component mount
  useEffect(() => {
    fetchReview();
  }, [token, bookId, fetchReview]);

  return (
    <div className="review-details">
      
      <div className="section-header">
        <h3 className="section-title">My Review</h3>
        {!error && (
          review ? (
            <button className="secondary-button details-buttons" onClick={handleReviewModal}>Edit</button>
          ) : (
            <button className="secondary-button details-buttons" onClick={handleReviewModal}>Create Review</button>
          )
        )}
      </div>

      {error ? <p className="error">Error fetching review</p> :
        (review ? (
          <div>
            <StarRating rating={review.rating} />
            {review.review_text && 
              <p>{review.review_text}</p>
            }
            <div className="review-details-section">
              {review.pace_review && 
                <p>Pace: <span className="review-details-selection">{review.pace_review} </span></p>
              }
              {review.plot_character_driven && 
                <p>Plot/Character Driven: <span className="review-details-selection">{review.plot_character_driven}</span></p>
              }
            </div>
            {review.development_review && <p>Development: {review.development_review}</p>}
          </div>
        ) : (
          <p>No review yet</p>
        ))
      }
      
      

      {/* Review modal */}
      {displayReviewModal && (
        <ReviewModal
          bookId={bookId}
          review={review}
          onClose={closeReviewModal}
          updatingReview={review !== null}
        />
      )}
      
    </div>
  );
}

export default ReviewDetails;
